import { Pipe, PipeTransform } from '@angular/core';
import {VizixService} from "../../providers/vizix.service";

/**
 * Generated class for the ValidateAssociationSecondFieldPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'validateAssociationSecondField',
})
export class ValidateAssociationSecondFieldPipe implements PipeTransform {
  constructor(private vizixService: VizixService){
  }
  transform(value: string) {
    let regExp = new RegExp(this.vizixService.configurationApp.AssociationConfiguration.FirstFieldValidation.value);
    console.log('validating tag: '+value+' with '+regExp);
    return regExp.test(value) ? value : '';
  }
}



// WEBPACK FOOTER //
// ./src/pipes/validate-tag/validate-association-second-field.ts